import React from 'react'
import { FaHeart } from 'react-icons/fa';
import './Footer.css'

function Footer() {
  return (
    <footer>
      <p>Codado com <FaHeart/> por <a href="https://www.linkedin.com/in/henriquegomesdev/">Henrique Gomes</a></p>
    </footer>
  )
}

export default Footer
